"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/BoundaryManager/ClickToSeeMore.jsx";

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

// Disabling lint warning about this not being a pure function
// because this needs to be able to take lat and lon props to work on the map layer
// and pure functions don't allow that.
// eslint-disable-next-line react/prefer-stateless-function
var ClickToSeeMore =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(ClickToSeeMore, _PureComponent);

  function ClickToSeeMore() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = ClickToSeeMore.prototype;

  _proto.render = function render() {
    return _react.default.createElement("div", {
      className: "see-all-homes-label-position",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      },
      __self: this
    }, _react.default.createElement("span", {
      className: "see-all-homes-label",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      },
      __self: this
    }, "Click to see"), _react.default.createElement("br", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14
      },
      __self: this
    }), _react.default.createElement("span", {
      className: "see-all-homes-label second-line",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      },
      __self: this
    }, "all homes"));
  };

  return ClickToSeeMore;
}(_react.PureComponent);

var _default = ClickToSeeMore;
exports.default = _default;